export default "__VITE_ASSET__e1hYT0hN__"